import { Parallax } from 'react-parallax';
import meandeleven from '../artifact/meandeleven.JPG';

function Ending({ isDarkMode, mainStyle }) {
  return (
    <div className="w-full">
      <Parallax
        bgImage={meandeleven}
        strength={700} // try 100–500 for more/less depth
        bgImageStyle={{ objectFit: 'cover' }}
      >
        <div className="w-full h-[60vh] md:h-[70vh] lg:h-[80vh] xl:h-[90vh] rounded-b-[30px]" />
      </Parallax>
      <p className='text-red-100'> Thanks for reading about me!</p>
    </div>
  );
}

export default Ending;